import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from 'ui/components/ConfirmDialog/ConfirmDialog'

type CloseWithoutSavingDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export function CloseWithoutSavingDialog({ open, onClose, onConfirm }: CloseWithoutSavingDialogProps): ReactNode {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open={open}
      initialFocus="deny"
      onClose={onClose}
      onConfirm={onConfirm}
      textObject={{
        title: t(`Do you really want to close without saving?`),
        text: t(
          `Currently you have an unsaved setting, are you completely sure you would like to exit without saving?`
        ),
      }}
    />
  )
}
